import type {
    default as PopoutData,
    DeeplinkPopoutData,
    ExtractedPopoutData,
} from '../store/schema/PopoutData';
import { getStore } from '../store/parentStore';

export default function extractData(data: DeeplinkPopoutData | PopoutData): ExtractedPopoutData {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (12,9): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    let projectionTabId: string = null;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (16,9): Type 'undefined' is not assignable to type 'DeeplinkPopoutData'.
    // @ts-expect-error
    let deeplinkData: DeeplinkPopoutData = undefined; // Use undefined as initial value since "null" is also a valid value of popout data
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (20,9): Type 'null' is not assignable to type 'Window'.
    // @ts-expect-error
    let projectionTargetWindow: Window = null;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (24,9): Type 'null' is not assignable to type 'Window'.
    // @ts-expect-error
    let projectionParentWindow: Window = null;
    if (data) {
        if (isPopoutData(data)) {
            deeplinkData = data.deeplinkData;
            if (getStore().isAvailable) {
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2322 (32,17): Type 'string | null' is not assignable to type 'string'.
                // @ts-expect-error
                projectionTabId = data.projectionTabId || null;
            }
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (37,13): Type 'Window | undefined' is not assignable to type 'Window'.
            // @ts-expect-error
            projectionTargetWindow = data.projectionTargetWindow;
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (41,13): Type 'Window | undefined' is not assignable to type 'Window'.
            // @ts-expect-error
            projectionParentWindow = data.projectionParentWindow;
        } else {
            deeplinkData = data;
        }
    }

    return {
        deeplinkCallback:
            typeof deeplinkData === 'undefined'
                ? // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                  // -> Error TS2352 (53,41): Conversion of type 'null' to type 'Object' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
                  // @ts-expect-error
                  () => Promise.resolve(<Object>null)
                : typeof deeplinkData === 'function'
                ? (deeplinkData as () => Promise<Object>)
                : () => Promise.resolve(deeplinkData),
        projectionTabId,
        projectionTargetWindow,
        projectionParentWindow,
    };
}

function isPopoutData(data: DeeplinkPopoutData | PopoutData): data is PopoutData {
    return (
        typeof (<PopoutData>data).deeplinkData != 'undefined' ||
        !!(<PopoutData>data).projectionTabId
    );
}
